import MainLayout from "@/components/layout/applicant/MainLayout.vue";
export default {
    name: "privacyPolicy",
    components: {
        MainLayout
    }
};